module.exports = __webpack_public_path__ + "static/media/S-Cert.cfeff475.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/S-Cert.svg
// module id = 295
// module chunks = 0